import React from 'react';
import { ShipmentsTable } from '../../components/ShipmentsTable';
import { ShipmentsExplorerFilters } from './ShipmentsExplorerFilter';

// tslint:disable-next-line:function-name
export function ShipmentsExplorer() {
  return <ShipmentsTable FiltersComponent={ShipmentsExplorerFilters}/>;
}
